import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { CatalogoFinalizar } from '@/features/catalogo/page/default/finalizar/CatalogoFinalizar';

const schema = z.object({
    venda_idpk: z.number().optional(),
});

export const Route = createFileRoute('/p/catalogo/$slug/_default/finalizar')({
    component: CatalogoFinalizar,
    validateSearch: schema,
});
